
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { ThemeProvider } from "@/hooks/use-theme"
import { BrowserRouter } from 'react-router-dom'

import { FeatureConfigProvider } from './contexts/FeatureConfigContext.tsx'
import { FeatureModelProvider } from './contexts/FeatureModelContext.tsx'
import ErrorBoundary from './components/ErrorBoundary.tsx'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <FeatureConfigProvider>
          <FeatureModelProvider>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </FeatureModelProvider>
        </FeatureConfigProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
